import React from 'react';

const Verbs = () => {
  return (
    <div className="gadject-container">
      <div className="gadject-head">What is a Verb (Òrò ìse)?</div>

      <div className="gadject-stuff">
        <div className="gadject-body">
          A verb simply is a word that is used to describe an action <br />
          For example;
        </div>

        <div className="noun-table-container">
          <div className="adverb -noun">
            <div className="noun-table">
              <p>shout</p>
              <p>sleep</p>
              <p>run</p>
              <p>jump</p>
              <p>dance</p>
              <p>read</p>
              <p>fight</p>
              <p>walk</p>
            </div>
            <div className="noun-table">
              <p>pariwo</p>
              <p>orun</p>
              <p>sá</p>
              <p>ìkánjú</p>
              <p>ijó</p>
              <p>nka</p>
              <p>jagun</p>
              <p>ìrìn</p>
            </div>
          </div>

          <div className="adverb -noun">
            <div className="noun-table">
              <p>smile</p>
              <p>drive</p>
              <p>write</p>
              <p>give</p>
              <p>take</p>
              <p>cry</p>
              <p>laugh</p>
              <p>sing</p>
            </div>
            <div className="noun-table">
              <p>rẹ́rìn-ín</p>
              <p>wakọ̀</p>
              <p>kọ</p>
              <p>fún</p>
              <p>gbà</p>
              <p>sunkún</p>
              <p>ẹ̀rín</p>
              <p>kọrin</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verbs;
